
    import Component from "vue-class-component";
    import Vue from "vue";
    import {
        MedicalCertificatesClient,
        AddMedicalCertificateRequest,
        factory,
MedicalCertificateActions
    } from "@/api-client";
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import FileUploader from "@/components/FileUploader.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import MedicalCertificateUpsertForm from "@/features/medicalCertificates/components/MedicalCertificateUpsertForm.vue";

    @Component({
        components: {
            LabelOptional,
            SectionPageHeading,
            FileUploader,
            MedicalCertificateUpsertForm
        }
    })
    export default class AddMedicalCertificate extends Vue {
        model: AddMedicalCertificateRequest = factory.create(AddMedicalCertificateRequest);
        seafarerId!: string;

        isCreated = false;
        canChooseInstitutionAndPractitioner = false;
        canOmitFile = false;
        actions: MedicalCertificateActions = factory.create(MedicalCertificateActions);
        
        async created() {
            this.seafarerId = this.$route.params.seafarerId

            const today = new Date();
            this.model.issuedOn = today;
            this.model.validUntil = new Date(today.getFullYear() + 2, today.getMonth(), today.getDate());
            this.model.vision.dateOfLastColorVisionTest = today;
            
            const listActions = await new MedicalCertificatesClient().availableListActions(this.seafarerId);
            this.actions = await new MedicalCertificatesClient().availableActions(null);
            this.canChooseInstitutionAndPractitioner = listActions.canChooseInstitutionAndPractitioner; // TODO(KK): Kind-of hackish...
            this.canOmitFile = listActions.canOmitFile;
            
            this.isCreated = true;
        }

        async submitCallback(request: AddMedicalCertificateRequest) {
            await new MedicalCertificatesClient()
                .add(request, this.seafarerId)
                .then(successResponse => this.$router.push({ path: `/seafarers/${this.seafarerId}/medical-certificates/${successResponse.id}` }));
        }
    }
